import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { CatalogEnvService } from '@aipb/gulliver/catalog/env';
import { LightboxDialogService } from '../lightbox-dialog';

@Component({
  selector: 'cat-lightbox-button',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslocoPipe],
  templateUrl: './lightbox-button.component.html',
  styleUrl: './lightbox-button.component.scss'
})
export class LightboxButtonComponent {
  @Input() searchId: string;
  @Input() index = 0;

  private lightboxDialog = inject(LightboxDialogService);
  catalogEnv = inject(CatalogEnvService);

  onOpen(evt: MouseEvent) {
    evt.stopPropagation();
    this.lightboxDialog.open({
      searchId: this.searchId,
      index: this.index
    });
  }
}
